import { useState, useEffect } from "react";

const useIsMobile = () => {
  const compute = () => {
    const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
    const uaMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    const coarse = typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(pointer: coarse)").matches : false;
    const smallW = typeof window !== "undefined" ? window.innerWidth < 768 : true;
    const smallH = typeof window !== "undefined" ? window.innerHeight < 600 : true;
    return uaMobile || (coarse && (smallW || smallH));
  };

  const [isMobile, setIsMobile] = useState(compute());

  useEffect(() => {
    const update = () => setIsMobile(compute());
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    let mql;
    if (window.matchMedia) {
      mql = window.matchMedia("(pointer: coarse)");
      mql.addEventListener?.("change", update);
    }
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
      mql && mql.removeEventListener?.("change", update);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
